export default "__VITE_ASSET__B$bTSDcF__"